<template>
  <svg
    version="1.2"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    overflow="visible"
    preserveAspectRatio="none"
    viewBox="0 0 331.95001220703125 235.66000366210938"
    id="Capa_1_1629393642182"
    width="180"
    height="127"
  >
    <g transform="translate(1, 1)">
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(315.14, -33.12, -22.23, -211.55, 80098.89, 85080.28)"
          y2="436.31"
          x2="-222.33"
          y1="436.54"
          x1="-223.34"
          id="Degradado_sin_nombre_35_1629393642182"
          vector-effect="non-scaling-stroke"
        >
          <stop
            stop-color="#f9f4d4"
            offset="0"
            vector-effect="non-scaling-stroke"
          />
          <stop
            stop-color="#ddf6ed"
            offset="1"
            vector-effect="non-scaling-stroke"
          />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          y2="150.59"
          x2="176.5"
          y1="256.37"
          x1="171.82"
          id="Degradado_sin_nombre_40_1629393642182"
          vector-effect="non-scaling-stroke"
        >
          <stop
            stop-color="#c65220"
            offset="0"
            vector-effect="non-scaling-stroke"
          />
          <stop
            stop-color="#c85725"
            offset="0.14"
            vector-effect="non-scaling-stroke"
          />
          <stop
            stop-color="#cf6433"
            offset="0.31"
            vector-effect="non-scaling-stroke"
          />
          <stop
            stop-color="#da794b"
            offset="0.5"
            vector-effect="non-scaling-stroke"
          />
          <stop
            stop-color="#ea986d"
            offset="0.69"
            vector-effect="non-scaling-stroke"
          />
          <stop
            stop-color="#f5ad84"
            offset="0.8"
            vector-effect="non-scaling-stroke"
          />
        </linearGradient>
        <mask
          maskUnits="userSpaceOnUse"
          height="39.33"
          width="192.93"
          y="170.25"
          x="54.61"
          vector-effect="non-scaling-stroke"
        >
          <g transform="translate(-7.21 -7.57)">
            <g id="mask-10_1629393642182">
              <polygon
                points="62.41 177.82 254.75 177.82 254.75 217.15 62.41 217.15 62.41 177.82"
                class="cls-1_1629393642182"
                fill="#fff"
                id="path-9_1629393642182"
                vector-effect="non-scaling-stroke"
              />
            </g>
          </g>
        </mask>
      </defs>
      <title>art_searching1</title>
      <g id="Symbols_1629393642182">
        <g id="Layout-Cards_Landing_Page_6_1629393642182">
          <path
            transform="translate(-7.21 -7.57)"
            d="M90.32,34.24a19.61,19.61,0,0,1,2,.39l29.61,7.58a112.94,112.94,0,0,1,40.47-12.1c42.88-4.5,82.49,15.77,103.76,49L285.08,84a22.31,22.31,0,0,1,16.55,24.8l-.16,1.13a19,19,0,0,1-21.08,16.17c-1.88,1-4.85,1.92-4.81,7.63.05,7.61,5.38,6.28,6.43,7.86l17.14,3.91a18.36,18.36,0,0,1,13.83,22v.07h0a18.53,18.53,0,0,1-22.15,13.87l-17.58-4-.12.25c-1.27,2.8-7.27-3.62-11.4,5.68s4.24,7.56,2.59,10c-.05.06-.09.13-.14.2a18.72,18.72,0,0,1,10,19.84,17,17,0,0,1-19.66,14l-.79-.16-19.45-4.25a111.14,111.14,0,0,1-49.73,17.73c-44,4.62-84.59-16.87-105.42-51.67l-24.49-5.36a18.75,18.75,0,0,1-14.47-21.45,17.06,17.06,0,0,1,19.67-13.95c.26,0,.53.09.79.15l4.73,1c0-.22,0-.39,0-.14v0c.11-2.26,5.13.91,6.52-7.94l0-.35c1.23-8.76-5.38-9.06-6.53-11l-19.47-4.44a18.37,18.37,0,0,1-13.82-22v-.07A18.51,18.51,0,0,1,54.25,89.61l19.66,4.48c2.58-1.19,8.73,3.26,12.43-4.73,4-8.6-3.32-10.94-2.66-13.51A22.31,22.31,0,0,1,68.6,51.48l.17-1.13A19,19,0,0,1,90.32,34.24ZM329.11,156.7c5.58,1.08,9.06,8.44,7.79,16.44s-6.82,13.6-12.4,12.51-9.06-8.44-7.79-16.44S323.54,155.61,329.11,156.7Zm-309-72.13c5.57,1.09,9,8.93,7.61,17.52s-7,14.67-12.57,13.58-9-8.92-7.61-17.51S14.51,83.49,20.09,84.57Z"
            class="cls-2_1629393642182"
            fill="url(#Degradado_sin_nombre_35_1629393642182)"
            id="Combined-Shape_1629393642182"
            vector-effect="non-scaling-stroke"
          />
        </g>
      </g>
      <g id="Group-5_1629393642182">
        <path
          transform="translate(-7.21 -7.57)"
          d="M65.09,149.36v0a.89.89,0,0,1,0-.11h0a1.36,1.36,0,0,0,0,.24v0l-4.71-1-.79-.16A17,17,0,0,0,40,162.22a18.65,18.65,0,0,0,14.4,21.35l24.37,5.34C99.52,223.56,139.9,245,183.72,240.35a110.65,110.65,0,0,0,49.49-17.64l19.35,4.23.79.15a17,17,0,0,0,19.58-13.89A18.68,18.68,0,0,0,263,193.44c.05-.06.09-.13.14-.2,1.64-2.41-6.69-.68-2.58-9.94s10.09-2.87,11.35-5.65l.12-.25,17.49,4a18.43,18.43,0,0,0,22.05-13.8v-.06a18.09,18.09,0,0,0,.07-7.78h-47.2c-15.77,0-13.91-4.13-37.36-4.13s-26.72-5.23-48.75-2-19.52-12.5-39.64-12.5-19.43,12.5-42.87,12.5c-14.52,0-21.75-3-29.6-5.27C65.57,148.51,65.12,148.71,65.09,149.36Z"
          class="cls-3_1629393642182"
          fill="url(#Degradado_sin_nombre_40_1629393642182)"
          vector-effect="non-scaling-stroke"
        />
      </g>
      <path
        transform="translate(-7.21 -7.57)"
        d="M73.66,156.65c-11.07,2.61,18.49.88,18.49.88s-10,5.15-7.73,6.27,14.65-.17,20.3-3.25,11.81-.26,14.38,1.54,12.7,4.29,13.93,3.56-3.8-4.29-4.88-6.24,11.25,1.91,11.25,1.91,11.46,2.62,10.27.26c-.25-.52-14.38-2.57-18.24-11.31-3.07-7-2.49-81.13-2.13-111-2.32,1-4.6,2.1-6.83,3.27L92.86,35c-.39-.1-.79-.16-1.18-.24l.47,100.78S93.24,152,73.66,156.65Z"
        class="cls-4_1629393642182"
        fill="#f7c4a7"
        vector-effect="non-scaling-stroke"
      />
      <path
        transform="translate(-7.21 -7.57)"
        d="M292,166.83c-.21-.42-9.65-1.87-15.21-7.12a13,13,0,0,1-3-4.18c-3.47-7.85-2.55-63.18-2.33-74.31l-6.64-1.7A106.23,106.23,0,0,0,234,48.31l.5,92.45a20.44,20.44,0,0,1-6.15,14.81A25.7,25.7,0,0,1,216,161.9c-11.07,2.62,18.49.88,18.49.88s-10,5.15-7.73,6.27,14.65-.17,20.3-3.25,11.82-.26,14.39,1.54,12.69,4.3,13.92,3.56-3.8-4.29-4.88-6.24,11.25,1.91,11.25,1.91S293.22,169.19,292,166.83Z"
        class="cls-5_1629393642182"
        fill="#f8cab0"
        vector-effect="non-scaling-stroke"
      />
      <path
        transform="translate(-7.21 -7.57)"
        d="M215.08,156.37c-.13-.26-3.77-.91-7.85-2.61s-8.47-4.36-10.39-8.69c-3.14-7.14-2.46-85-2.1-113.19A111.16,111.16,0,0,0,161,30.32c-1.32.14-2.64.31-3.95.49l.47,99.49a20.45,20.45,0,0,1-5.48,14.14c-2.74,2.92-6.85,5.55-13,7-11.07,2.62,18.49.88,18.49.88s-10,5.15-7.73,6.27,14.65-.17,20.3-3.25,11.81-.26,14.38,1.54,12.7,4.3,13.93,3.56-3.8-4.29-4.88-6.24,11.25,1.91,11.25,1.91S216.27,158.73,215.08,156.37Z"
        class="cls-6_1629393642182"
        fill="#f5ad84"
        vector-effect="non-scaling-stroke"
      />
      <g id="Group-103_1629393642182">
        <path
          transform="translate(-7.21 -7.57)"
          d="M123.1,160.22c-1.5-3.57-31.2-57.17,18.81-74.22,39.92-13.62,8,17.87,8,17.87L134.17,138s-5.75,25.91-11.07,22.22"
          class="cls-7_1629393642182"
          fill="#0b2679"
          id="Fill-1_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M210,170.58c0,5.52-6.72,10-15,10s-15-4.48-15-10,6.71-10,15-10,15,4.48,15,10"
          class="cls-8_1629393642182"
          fill="#ba5f45"
          id="Fill-3_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M187.32,117s-7.76-34.42-59.61-13.93l-28.17,3.28s-2.86,0,4.49,6.15,21.23,20.89,21.23,20.89l-9.8,37.29s71.86,35.65,90.23,11.47c0,0,8.58,6.56-18.37-65.15"
          class="cls-9_1629393642182"
          fill="#345cd7"
          id="Fill-5_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M107,107.58a5,5,0,1,1-5-5,5,5,0,0,1,5,5"
          class="cls-10_1629393642182"
          fill="#e76289"
          id="Fill-7_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <g id="Group-11_1629393642182">
          <g class="cls-11_1629393642182" mask="url(#mask)">
            <path
              transform="translate(-7.21 -7.57)"
              d="M62,197.49c-.46,1.06-.69,12,9.67,8.24s29.94,0,29.94,0,16.12,13,28.79,11.18,5.76-11.18,17.27-9.31,23,11.17,33.4,9.31,13.82-14.9,19.57-13,24.18,16.76,25.34,1.86c0,0,23,13,28.78-7.45,0,0-10.77-1.33-32.65-16.23S62.45,196.42,62.45,196.42Z"
              class="cls-8_1629393642182"
              fill="#ba5f45"
              id="Fill-9_1629393642182"
              vector-effect="non-scaling-stroke"
            />
          </g>
        </g>
        <polygon
          points="117.79 125.01 128.78 135.34 125.64 165.1 115.13 169.01 108.78 162.62 117.79 125.01"
          class="cls-12_1629393642182"
          fill="#0f33a1"
          id="Fill-12_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M117.14,164.58S103.36,165.71,93,179.2s-31,16.87-31,16.87-1.15,7.87,9.18,5.62,29.86,0,29.86,0,16.07,7.87,28.71,6.74,5.74-6.74,17.22-5.62,23,6.75,33.3,5.62,13.78-9,19.52-7.87,24.11,10.12,25.26,1.13c0,0,23,7.87,28.71-4.5,0,0,3.45-1.12-18.37-10.12s-26.41-18-26.41-18a14,14,0,0,0-13.78,4.5c-5.74,6.74-9.19-3.38-14.93-2.25s-8,9-12.63,7.87-1.15-3.37-9.19-4.5-18.37-4.5-25.26-1.12-16.08-9-16.08-9"
          class="cls-13_1629393642182"
          fill="#f0894f"
          id="Fill-14_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M93.58,179.38c-9.52,10.71-23.74,15.45-29.8,17.28-2.9.87-1.41.92-1.38.92,13.71-3.53,32.75-13.93,60.06-19.8,21.21-4.56,39.59-2.45,36.1-2.95-8-1.13-18.24-4.55-25.08-1.13s-16-9.1-16-9.1S107.67,163.56,93.58,179.38Z"
          class="cls-8_1629393642182"
          fill="#ba5f45"
          id="Fill-16_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M93.66,178.16C83.24,191.6,61.87,196.34,62,196.34c37.05,2.4,33.26-14,61-19.76"
          class="cls-8_1629393642182"
          fill="#ba5f45"
          id="Fill-18_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M179,185.92s-2.16,2.66-8.74,2.66a26.37,26.37,0,0,1-11.48-2.66c-1.26,0-.7-9.12-.45-10.49a75.23,75.23,0,0,1,5.17-15.22,47.21,47.21,0,0,1,6-8.63l11.53,3.7V183.7a2.12,2.12,0,0,1-2,2.22"
          class="cls-12_1629393642182"
          fill="#0f33a1"
          id="Fill-20_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M184.94,183.08s-2.24,2.5-9,2.5a29.37,29.37,0,0,1-11.86-2.5,2.07,2.07,0,0,1-2-2.5s1.92-14.39,3.24-19c2.42-8.47,4.88-11,4.88-11L187,154.33V181a2.07,2.07,0,0,1-2.05,2.08"
          class="cls-9_1629393642182"
          fill="#345cd7"
          id="Fill-22_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M178.7,183.83l.1,0,0,.14c0-.06-.05-.11-.07-.16m-7-.42-.19-.29h.25l-.06.3m13.85.9a1.3,1.3,0,0,0,0-.52l-1.17-5.46s-9.85-5.07-13.37-5.45c-12.49-1.36-13,2.39-13,2.39l.06,8.19a1.41,1.41,0,0,0,.07.5,4.36,4.36,0,0,0,.09.69,3.94,3.94,0,0,0,.21.69l-.13-.06,3.06,5.38c.32.71,1.69.76,1.93.07l1-3.26a3,3,0,0,0,.7-2.82,4.07,4.07,0,0,0-.22-.7l.14,0a3.16,3.16,0,0,0,.08.74,4.43,4.43,0,0,0,1.12,2.07l2.62,4.62c.32.71,1.69.76,1.93.07l1.51-4.89-.11,0a2.53,2.53,0,0,0,.19-.68,5.2,5.2,0,0,0,.7.92l-.36-.16,3.06,5.38c.32.71,1.69.76,1.93.07l1.51-4.88a5.59,5.59,0,0,1-.81.19,2.81,2.81,0,0,0,.65-1.09,4.71,4.71,0,0,0,1.31,1.87l2.18,3.84c.33.71,1.7.76,1.93.07l1.51-4.89,0,0a3.63,3.63,0,0,0,.16-1.49,4.38,4.38,0,0,0-.41-1.42"
          class="cls-8_1629393642182"
          fill="#ba5f45"
          id="Fill-24_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M180.77,182.27a.58.58,0,0,0,0-.19l.09,0-.06.17m-6.17-1.05-.12.36a3.58,3.58,0,0,0-.11-.35h.23m12.27,1.44A1.8,1.8,0,0,0,187,182v-8.6s-7.94-4-11.06-4.5c-11.06-1.64-12.29,2.86-12.29,2.86l-1.55,9.83a2.05,2.05,0,0,0,0,.6,5.69,5.69,0,0,0-.06.83c0,2.38,1.37,4.3,3.07,4.3s3.07-1.92,3.07-4.3a5.73,5.73,0,0,0-.06-.84l.13,0a6.27,6.27,0,0,0-.07.88c0,2.38,1.47,4.3,3.28,4.3a3.45,3.45,0,0,0,3.07-2.81,3.45,3.45,0,0,0,3.08,2.81,3.3,3.3,0,0,0,2.9-2.3c.23,1.9,1.37,3.38,2.86,3.51,1.8.16,3.43-1.73,3.65-4.2a6,6,0,0,0-.1-1.71"
          class="cls-10_1629393642182"
          fill="#e76289"
          id="Fill-26_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M163.77,190,162,184.58a7.73,7.73,0,0,0,3,.92,8.89,8.89,0,0,0,3-.35l-2.41,4.94c-.36.69-1.65.64-1.81-.07"
          class="cls-14_1629393642182"
          fill="#fdf2fe"
          id="Fill-28_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M169.77,191,168,185.58a7.73,7.73,0,0,0,3,.92,8.89,8.89,0,0,0,3-.35l-2.42,4.94c-.36.69-1.64.64-1.8-.07"
          class="cls-14_1629393642182"
          fill="#fdf2fe"
          id="Fill-30_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M176.78,192,175,186.58a7.73,7.73,0,0,0,3,.92,8.89,8.89,0,0,0,3-.35l-2.41,4.94c-.36.69-1.65.64-1.8-.07"
          class="cls-14_1629393642182"
          fill="#fdf2fe"
          id="Fill-32_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M181.78,192,180,186.58a7.73,7.73,0,0,0,3,.92,8.89,8.89,0,0,0,3-.35l-2.41,4.94c-.36.69-1.65.64-1.8-.07"
          class="cls-14_1629393642182"
          fill="#fdf2fe"
          id="Fill-34_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <polygon
          points="120.15 128.01 119.78 137.12 121.28 137.94 122.4 134.63 122.4 138.77 124.28 140.01 125.78 133.81 120.15 128.01"
          class="cls-15_1629393642182"
          fill="#beb5bf"
          id="Fill-36_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <polygon
          points="120.16 128.01 119.78 137.44 121.31 138.3 122.47 134.87 122.47 139.15 123.62 140.01 124.78 132.73 120.16 128.01"
          class="cls-14_1629393642182"
          fill="#fdf2fe"
          id="Fill-38_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M140,205.44s6.19-7.63,4.34-12.82,2.78,10.61,7.75,13-12.09-.14-12.09-.14"
          class="cls-8_1629393642182"
          fill="#ba5f45"
          id="Fill-40_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M192,203.06s5.17-11.13,2.67-18.09S198.77,199.31,204,202s-12,1-12,1"
          class="cls-8_1629393642182"
          fill="#ba5f45"
          id="Fill-42_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M145.17,183.58a1.69,1.69,0,0,0-.67,0c-.05-1.75-.55-3-1.28-3-.94,0-1.91,2-2.17,4.47-.2,2,.1,3.64.69,4.29.06,1.73.75,3.06,1.81,3.22,1.38.22,2.86-1.62,3.31-4.1s-.31-4.67-1.69-4.88"
          class="cls-8_1629393642182"
          fill="#ba5f45"
          id="Fill-44_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M184,110.29c8.63,4.55-11.51,25.63-44,6.2-13.76-8.23-18.09-10.75-9.87-13.23,11.55-3.48,18.32-17.23,33.71-12.81s10.73,14.88,20.14,19.84"
          class="cls-12_1629393642182"
          fill="#0f33a1"
          id="Fill-46_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M187.8,113.72c-.3-.16-.58-.33-.86-.51-.43-10-5.79-25.8-19.57-29.7-12.81-3.62-24.11,4-32.63,11.82A28.5,28.5,0,0,1,130.46,97c-8.19,2.44,5.37,15.26,20.48,20.34,27.85,9.35,45.46.81,36.86-3.66"
          class="cls-16_1629393642182"
          fill="#ffe848"
          id="Fill-48_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M187.8,113.69c-.3-.16-.58-.33-.86-.51-6.39,4.25-17.16,4.81-30.95.9-12.81-3.64-19.69-10-23.39-17.5-1.4.69-.68-.08-2.14.36-8.19,2.45,5.37,15.33,20.48,20.42,27.85,9.39,45.46.82,36.86-3.67"
          class="cls-17_1629393642182"
          fill="#ffed6d"
          id="Fill-50_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M144.59,101.58c-2.41,3.82-7.09,5.14-10.46,2.93s-4.15-7.1-1.74-10.93,7.09-5.13,10.46-2.93,4.15,7.1,1.74,10.93"
          class="cls-18_1629393642182"
          fill="#f3a93b"
          id="Fill-52_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M156.14,102.21c-9.23-2-16.25-5.81-19.5-8.63-1.92,1.29-3.71,2.62-5.37,3.91-2,1.58,7,8.82,21.22,12s33.5,4.75,33.5.65a22.08,22.08,0,0,0-.63-5c-6.47.82-19.1-.63-29.22-2.88"
          class="cls-18_1629393642182"
          fill="#f3a93b"
          id="Fill-54_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M140.28,101.48c8.55-7.79,19.91-15.32,32.77-11.73A22.16,22.16,0,0,1,181,93.83a23.55,23.55,0,0,0-12.88-9.32c-12.86-3.6-24.22,3.93-32.77,11.72a28.68,28.68,0,0,1-4.3,1.7c-4.7,1.38,7.84,4.23,9.24,3.55"
          class="cls-18_1629393642182"
          fill="#f3a93b"
          id="Fill-56_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M140.53,98.88c-1.95,3.06-5.11,4.51-7.07,3.24s-2-4.77,0-7.83,5.12-4.52,7.08-3.25,2,4.78,0,7.84"
          class="cls-1_1629393642182"
          fill="#fff"
          id="Fill-58_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M145.59,99.58s-1.53,5.32-4.6,5.86l2.6,1.14s2.42-1.18,4.4-6Z"
          class="cls-13_1629393642182"
          fill="#f0894f"
          id="Fill-60_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M167,222.58c0,1.66-2.46,3-5.5,3s-5.5-1.34-5.5-3,2.46-3,5.5-3,5.5,1.34,5.5,3"
          class="cls-19_1629393642182"
          fill="#6d2f1e"
          id="Fill-66_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M167,220.58c0,1.66-2.24,3-5,3s-5-1.34-5-3,2.24-3,5-3,5,1.34,5,3"
          class="cls-8_1629393642182"
          fill="#ba5f45"
          id="Fill-68_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M206,219.58c0,1.66-1.79,3-4,3s-4-1.34-4-3,1.79-3,4-3,4,1.34,4,3"
          class="cls-19_1629393642182"
          fill="#6d2f1e"
          id="Fill-70_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M206,218.08c0,1.38-1.57,2.5-3.5,2.5s-3.5-1.12-3.5-2.5,1.57-2.5,3.5-2.5,3.5,1.12,3.5,2.5"
          class="cls-8_1629393642182"
          fill="#ba5f45"
          id="Fill-72_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M244,214.58c0,1.66-2.46,3-5.5,3s-5.5-1.34-5.5-3,2.46-3,5.5-3,5.5,1.34,5.5,3"
          class="cls-19_1629393642182"
          fill="#6d2f1e"
          id="Fill-74_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M244,214.08c0,1.38-2.24,2.5-5,2.5s-5-1.12-5-2.5,2.24-2.5,5-2.5,5,1.12,5,2.5"
          class="cls-8_1629393642182"
          fill="#ba5f45"
          id="Fill-76_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M158,216.58c0,1.66-1.79,3-4,3s-4-1.34-4-3,1.79-3,4-3,4,1.34,4,3"
          class="cls-19_1629393642182"
          fill="#6d2f1e"
          id="Fill-87_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M159,216.08c0,1.38-1.57,2.5-3.5,2.5s-3.5-1.12-3.5-2.5,1.57-2.5,3.5-2.5,3.5,1.12,3.5,2.5"
          class="cls-8_1629393642182"
          fill="#ba5f45"
          id="Fill-89_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M156.66,84.61a.36.36,0,0,1,0,.1l-.09-.09h.07m-4.33,1.54.06.22-.2-.15.14-.07M163,88.07l-1.2-3.85-.08.11a4.89,4.89,0,0,0-.25-.52c-.19-.32-5.91-2.66-13.75.11s-3.62,3.82-3.62,3.82l.39,2.63a1.11,1.11,0,0,0,.21.32,2.68,2.68,0,0,0,.27.45,3.73,3.73,0,0,0,.58.61h-.19L149,94.43c.43.38,1.23,0,1.12-.55L149.45,91a2.75,2.75,0,0,0-.57-1.87,3.62,3.62,0,0,0-.36-.42l.07-.06a4.09,4.09,0,0,0,.29.48,3.44,3.44,0,0,0,1.38,1.11l3.15,2.33c.43.37,1.23,0,1.12-.55l-.84-3.76-.08.09a2.73,2.73,0,0,0-.1-.48l.21.14h0l3.62,2.67c.43.38,1.23,0,1.13-.55l-.85-3.76,0,0a1.23,1.23,0,0,0,0-.2,3.41,3.41,0,0,0,1.71,1l2.63,1.55a.74.74,0,0,0,1.1-.73"
          class="cls-20_1629393642182"
          id="Fill-91_1629393642182"
          vector-effect="non-scaling-stroke"
          style="fill-opacity: 0.3"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M157.59,82.92a.94.94,0,0,1-.1-.1h.07l0,.11m-4.54,1.58a2.17,2.17,0,0,0,.07.24l-.21-.16.14-.08m-4.83-2.45c-8,3-4.43,7.56-4.43,7.56l1.07-.47a1.13,1.13,0,0,0,.21.35,4.29,4.29,0,0,0,.29.5c.93,1.35,2.6,2,3.73,1.36s1.3-2.18.37-3.53a4.14,4.14,0,0,0-.37-.46l.07-.07a3.12,3.12,0,0,0,.3.53,3.18,3.18,0,0,0,3.87,1.3,2.2,2.2,0,0,0,.95-2.69,2.92,2.92,0,0,0,3.15.52,2.12,2.12,0,0,0,1-2.33,3,3,0,0,0,3.28,1c1.27-.55,1.62-2.2.79-3.68-.2-.36-6.16-2.93-14.32.11"
          class="cls-10_1629393642182"
          fill="#e76289"
          id="Fill-93_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M148.8,92.45,145,90.05a7.06,7.06,0,0,0,2.37-.4,5.43,5.43,0,0,0,1.73-1.07L150,92c.11.48-.73.84-1.18.5"
          class="cls-14_1629393642182"
          fill="#fdf2fe"
          id="Fill-95_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M152.8,90.45,149,88.05a7.06,7.06,0,0,0,2.37-.4,5.61,5.61,0,0,0,1.74-1.07L154,90c.11.48-.73.84-1.18.5"
          class="cls-14_1629393642182"
          fill="#fdf2fe"
          id="Fill-97_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M158.8,88.45,155,86.05a7.06,7.06,0,0,0,2.37-.4,5.61,5.61,0,0,0,1.74-1.07L160,88c.11.48-.73.84-1.18.5"
          class="cls-14_1629393642182"
          fill="#fdf2fe"
          id="Fill-99_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M161.88,86.49l-3.89-2a6.64,6.64,0,0,0,2.24-.65,5.14,5.14,0,0,0,1.55-1.26L163,85.87c.15.47-.62.91-1.09.62"
          class="cls-14_1629393642182"
          fill="#fdf2fe"
          id="Fill-101_1629393642182"
          vector-effect="non-scaling-stroke"
        />
      </g>
      <g id="acc.._1629393642182">
        <path
          transform="translate(-7.21 -7.57)"
          d="M33.89,55.51a6.64,6.64,0,1,1,6.67-6.63A6.65,6.65,0,0,1,33.89,55.51Zm0-2.41a4.23,4.23,0,1,0-4.24-4.22A4.23,4.23,0,0,0,33.89,53.1Z"
          class="cls-21_1629393642182"
          fill="#f3a93c"
          id="Oval-Copy-2_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M119.21,20.84a6.64,6.64,0,1,1,6.67-6.63A6.65,6.65,0,0,1,119.21,20.84Zm0-2.41A4.23,4.23,0,1,0,115,14.21,4.23,4.23,0,0,0,119.21,18.43Z"
          class="cls-21_1629393642182"
          fill="#f3a93c"
          id="Oval-Copy-3_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M320.91,231.84a6.64,6.64,0,1,1,6.67-6.63A6.65,6.65,0,0,1,320.91,231.84Zm0-2.41a4.23,4.23,0,1,0-4.25-4.22A4.23,4.23,0,0,0,320.91,229.43Z"
          class="cls-21_1629393642182"
          fill="#f3a93c"
          id="Oval-Copy_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <path
          transform="translate(-7.21 -7.57)"
          d="M285.91,57.84a6.64,6.64,0,1,1,6.67-6.63A6.65,6.65,0,0,1,285.91,57.84Zm0-2.41a4.23,4.23,0,1,0-4.25-4.22A4.23,4.23,0,0,0,285.91,55.43Z"
          class="cls-21_1629393642182"
          fill="#f3a93c"
          id="Oval-Copy-5_1629393642182"
          vector-effect="non-scaling-stroke"
        />
        <g id="Group_1629393642182">
          <path
            transform="translate(-7.21 -7.57)"
            d="M19.55,136.77l.12,4.61a1,1,0,0,0,1,1,1,1,0,0,0,1-1l-.13-4.61a1,1,0,0,0-2,.05Z"
            class="cls-22_1629393642182"
            fill="#00c59d"
            id="Line_1629393642182"
            vector-effect="non-scaling-stroke"
          />
          <path
            transform="translate(-7.21 -7.57)"
            d="M18.77,144.7l-4.61,0a1,1,0,0,1-1-1,1,1,0,0,1,1-1l4.61,0a1,1,0,0,1,0,2Z"
            class="cls-22_1629393642182"
            fill="#00c59d"
            id="Line-Copy_1629393642182"
            vector-effect="non-scaling-stroke"
          />
          <path
            transform="translate(-7.21 -7.57)"
            d="M19.7,146.34l0,4.61a1,1,0,1,0,2,0l0-4.61a1,1,0,0,0-2,0Z"
            class="cls-22_1629393642182"
            fill="#00c59d"
            id="Line-Copy-3_1629393642182"
            vector-effect="non-scaling-stroke"
          />
          <path
            transform="translate(-7.21 -7.57)"
            d="M28,144.64l-4.61,0a1,1,0,1,1,0-2l4.61,0a1,1,0,0,1,0,2Z"
            class="cls-22_1629393642182"
            fill="#00c59d"
            id="Line-Copy-2_1629393642182"
            vector-effect="non-scaling-stroke"
          />
        </g>
        <g id="Group-2_1629393642182">
          <path
            transform="translate(-7.21 -7.57)"
            d="M295.39,191.63l.13,4.6a1,1,0,0,0,1,1,1,1,0,0,0,1-1l-.13-4.61a1,1,0,0,0-1-1A1,1,0,0,0,295.39,191.63Z"
            class="cls-22_1629393642182"
            fill="#00c59d"
            id="Line-2_1629393642182"
            vector-effect="non-scaling-stroke"
          />
          <path
            transform="translate(-7.21 -7.57)"
            d="M294.61,199.56l-4.61,0a1,1,0,0,1-1-1,1,1,0,0,1,1-1l4.61,0a1,1,0,0,1,1,1A1,1,0,0,1,294.61,199.56Z"
            class="cls-22_1629393642182"
            fill="#00c59d"
            id="Line-Copy-2-2_1629393642182"
            vector-effect="non-scaling-stroke"
          />
          <path
            transform="translate(-7.21 -7.57)"
            d="M295.54,201.19l0,4.61a1,1,0,0,0,1,1,1,1,0,0,0,1-1l0-4.61a1,1,0,0,0-2,0Z"
            class="cls-22_1629393642182"
            fill="#00c59d"
            id="Line-Copy-3-2_1629393642182"
            vector-effect="non-scaling-stroke"
          />
          <path
            transform="translate(-7.21 -7.57)"
            d="M303.83,199.49l-4.61,0a1,1,0,1,1,0-2l4.61,0a1,1,0,0,1,0,2Z"
            class="cls-22_1629393642182"
            fill="#00c59d"
            id="Line-Copy-2-3_1629393642182"
            vector-effect="non-scaling-stroke"
          />
        </g>
        <g id="Group-3_1629393642182">
          <path
            transform="translate(-7.21 -7.57)"
            d="M319.16,109.25l.13,4.61a1,1,0,0,0,1,1,1,1,0,0,0,1-1l-.13-4.6a1,1,0,0,0-1-1A1,1,0,0,0,319.16,109.25Z"
            class="cls-22_1629393642182"
            fill="#00c59d"
            id="Line-3_1629393642182"
            vector-effect="non-scaling-stroke"
          />
          <path
            transform="translate(-7.21 -7.57)"
            d="M318.39,117.18l-4.61,0a1,1,0,0,1-1-1,1,1,0,0,1,1-1l4.61,0a1,1,0,1,1,0,2Z"
            class="cls-22_1629393642182"
            fill="#00c59d"
            id="Line-Copy-3-3_1629393642182"
            vector-effect="non-scaling-stroke"
          />
          <path
            transform="translate(-7.21 -7.57)"
            d="M319.32,118.82l0,4.61a1,1,0,0,0,1,1,1,1,0,0,0,1-1l0-4.61a1,1,0,0,0-1-1A1,1,0,0,0,319.32,118.82Z"
            class="cls-22_1629393642182"
            fill="#00c59d"
            id="Line-Copy-3-4_1629393642182"
            vector-effect="non-scaling-stroke"
          />
          <path
            transform="translate(-7.21 -7.57)"
            d="M327.61,117.12l-4.61,0a1,1,0,1,1,0-2l4.61,0a1,1,0,0,1,1,1A1,1,0,0,1,327.61,117.12Z"
            class="cls-22_1629393642182"
            fill="#00c59d"
            id="Line-Copy-2-4_1629393642182"
            vector-effect="non-scaling-stroke"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  name: 'ArtSearchingIcon',
}
</script>
